import { UserRoleEnum } from "@/api/user/models";
import { ClosingLocationEnum } from "@/enums/talent";

//Closing locations que permitem usuários de booker ou casting excluirem um talento
export const ALLOWED_LOCATIONS = [ClosingLocationEnum.BABY, ClosingLocationEnum.VOGUE, ClosingLocationEnum.YOUNIQUE];

export const RESTRICTED_ROLES = [UserRoleEnum.COORDINATOR, UserRoleEnum.BOOKER];

export const COLLABORATORS_MANAGEMENT_ROLES = [UserRoleEnum.ADMINISTRATOR, UserRoleEnum.COORDINATOR];

export const REJECTED_CANDIDATES_ALLOWED_ROLES = [
  UserRoleEnum.ADMINISTRATOR,
  UserRoleEnum.COORDINATOR,
  UserRoleEnum.PRODUCER,
];

export const SCHEDULE_CREATION_ALLOWED_ROLES = [
  UserRoleEnum.ADMINISTRATOR,
  UserRoleEnum.COORDINATOR,
  UserRoleEnum.RECEPTIONIST,
];

/** Roles que têm permissão para exportar talentos. */
export const TALENT_EXPORT_ALLOWED_ROLES = [UserRoleEnum.ADMINISTRATOR, UserRoleEnum.COORDINATOR];

/** Roles que podem editar dados de talento no Casting. */
export const TALENT_EDIT_ALLOWED_ROLES = [
  UserRoleEnum.ADMINISTRATOR,
  UserRoleEnum.COORDINATOR,
  UserRoleEnum.BOOKER,
  UserRoleEnum.RELATIONSHIP_COORDINATOR,
];

/** Roles que podem acessar composites no Casting. */
export const COMPOSITE_ACCESS_ALLOWED_ROLES = [
  UserRoleEnum.ADMINISTRATOR,
  UserRoleEnum.COORDINATOR,
  UserRoleEnum.BOOKER,
];
